export const PACKAGING_LEVEL1_ALL_PACKAGE_SUCCESS = "auth/PACKAGING_LEVEL1_ALL_PACKAGE_SUCCESS";
export const PACKAGING_LEVEL1_ALL_PACKAGE_FAILURE = "auth/PACKAGING_LEVEL1_ALL_PACKAGE_FAILURE";
export const ADD_PACKAGE_TO_LEVEL2_SUCCESS = "auth/ADD_PACKAGE_TO_LEVEL2_SUCCESS";
export const ADD_PACKAGE_TO_LEVEL2_FAILURE = "auth/ADD_PACKAGE_TO_LEVEL2_FAILURE";